import { USER_USERINFO_CLEAR, USER_USERINFO_UPDATE } from '../mutationTypes';

const initState = {
  userInfo: {},
  registerInfo: {
    phone: '',
    invite: '',
    password: '',
    rPassword: '',
    code: '',
    biz: '',
  },
  registerWechatInfo: {
    phone: '',
    invite: '',
    password: '',
    rPassword: '',
    code: '',
    biz: '',
    wechatId: '',
    city: '杭州',
    country: '',
    headimgurl: '',
    language: '',
    nickname: '',
    openid: '',
    province: '',
    sex: 1,
    unionid: '',
  },
};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};
const getters = {};
const mutations = {
  // 用户信息清除
  [USER_USERINFO_CLEAR](states, newValue = initState.registerInfo) {
    const registerInfo = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { registerInfo });
  },
  // 用户信息更新
  [USER_USERINFO_UPDATE](states, newValue = state.userInfo) {
    const userInfo = Object.assign(state.userInfo, newValue);
    Object.assign(states, { userInfo });
  },
};
const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
